import React from "react";

const ImagePreview = ({imageFile}) =>
  imageFile.map(({name, preview, size}) => (
    <div key={name} className={'file-preview'}>
      <b>Documento {name.split('.')[1]}:</b>
      <p>{name}</p>
    </div>
  ));

export default ImagePreview;
